export const primitiveUnhandledValue = 'Non-Error promise rejection captured with value:';
export const primitiveUnhandledType = 'UnhandledRejection';

export const domErrorType = 'DOMError';
export const domExceptionType = 'DOMException';

export const objectEventValue = 'Non-Error exception captured with keys:';

export const unknownSymbolString = '?';

export const valueTypeRegex =
  /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
